import {defineMessages} from 'react-intl';

const messages = defineMessages({
    TITLE: {
        id: 'techDoc.list.title',
        defaultMessage: 'List documentations'
    },
    INTERNAL_TICKET_TITLE: {
        id: 'techDoc.list.titleInternalTicket',
        defaultMessage: 'List documentations - Internal Ticket'
    },
    VISIBLE_COLUMNS: {
        id: 'techDoc.list.label.visibleColumns',
        defaultMessage: 'Visible columns'
    },
    TABLE_TICKET_NUMBER: {
        id: 'techDoc.list.table.ticketNo',
        defaultMessage: 'Ticket No.'
    },
    TABLE_SOLUTION_GROUP: {
        id: 'techDoc.list.table.solutionGroup',
        defaultMessage: 'Solution Gr.'
    },
    TABLE_ORDER_CREATION_TIME: {
        id: 'techDoc.list.table.creationDate',
        defaultMessage: 'Creation Date'
    },
    TABLE_CLIENT_ID: {
        id: 'techDoc.list.table.clientId',
        defaultMessage: 'Client ID'
    },
    TABLE_DEALER_NUMBER: {
        id: 'techDoc.list.table.dealerNumber',
        defaultMessage: 'Dealer No.'
    },
    TABLE_DEALER_NAME: {
        id: 'techDoc.list.table.dealerName',
        defaultMessage: 'Dealer Name'
    },
    TABLE_PR: {
        id: 'techDoc.list.table.pr',
        defaultMessage: 'PR'
    },
    TABLE_REG_DIR: {
        id: 'techDoc.list.table.regDir',
        defaultMessage: 'Reg. Dir.'
    },
    TABLE_COUNTRY_CODE_3: {
        id: 'techDoc.list.table.countryCode3',
        defaultMessage: 'Country Code'
    },
    TABLE_PART_DESCRIPTION: {
        id: 'techDoc.list.table.partDescription',
        defaultMessage: 'Part Description'
    },
    TABLE_MANAGEMENT_GROUP: {
        id: 'techDoc.list.table.managementGroup',
        defaultMessage: 'Management Group'
    },
    TABLE_INTERNAL_STATUS: {
        id: 'techDoc.list.table.internalStatus',
        defaultMessage: 'Internal status'
    },
    TABLE_FORM_TYPE: {
        id: 'techDoc.list.table.formType',
        defaultMessage: 'Type of Form'
    },
    TABLE_STATUS: {
        id: 'techDoc.list.table.status',
        defaultMessage: 'Status'
    },
    TABLE_LAST_STATUS_DATE: {
        id: 'techDoc.list.table.lastStatusDate',
        defaultMessage: 'Last Status Date'
    },
    TABLE_LAST_EDITOR: {
        id: 'techDoc.list.table.lastEditor',
        defaultMessage: 'Last Editor'
    },
    TABLE_CREATED_BY: {
        id: 'techDoc.list.table.createdBy',
        defaultMessage: 'Created by (IPN)'
    },
    TABLE_PAGE1: {
        id: 'techDoc.list.table.page1',
        defaultMessage: 'Page 1'
    },
    TABLE_PAGE2: {
        id: 'techDoc.list.table.page2',
        defaultMessage: 'Page 2'
    },
    TABLE_PROBLEM_TYPE: {
        id: 'techDoc.list.table.problemType',
        defaultMessage: 'Type of Problem'
    },
    TABLE_VOR_RELATED: {
        id: 'techDoc.list.table.vorRelated',
        defaultMessage: 'VOR/PVI related'
    },
    TABLE_IMMOBILIZED_VEHICLE: {
        id: 'techDoc.list.table.immobilizedVehicle',
        defaultMessage: 'Immobilized Vehicle'
    },
    TABLE_TYPE_OF_CLIENT: {
        id: 'techDoc.list.table.typeOfClient',
        defaultMessage: 'Type of Client'
    },
    TABLE_SRC_TYPE: {
        id: 'techDoc.list.table.srcType',
        defaultMessage: 'SRC Type'
    },
    TABLE_SRC_N: {
        id: 'techDoc.list.table.srcN',
        defaultMessage: 'SRC N°'
    },
    PVI_RELATED_OPTION_NO: {
        id: 'techDoc.list.table.pviRelatedOptionNo',
        defaultMessage: 'No'
    },
    TABLE_INTERNAL_TICKET_NUMBER: {
        id: 'techDoc.internalList.table.ticketNo',
        defaultMessage: 'Internal Ticket No.'
    },
    TABLE_REQUEST_TYPE: {
        id: 'techDoc.internalList.table.requestType',
        defaultMessage: 'Request Type'
    },
    TABLE_REQUEST_STATUS: {
        id: 'techDoc.internalList.table.requestStatus',
        defaultMessage: 'Request Status'
    },
    TABLE_PRIORITY: {
        id: 'techDoc.internalList.table.priority',
        defaultMessage: 'Priority'
    },
    TABLE_PRIORITY_TYPE: {
        id: 'techDoc.internalList.table.priorityType',
        defaultMessage: 'Priority Type'
    },
    TABLE_DEALER_TICKET_NUMBER: {
        id: 'techDoc.internalList.table.dealerTicketNo',
        defaultMessage: 'Dealer Ticket No.'
    },
    TABLE_DEALER_FORM_TYPE: {
        id: 'techDoc.internalList.table.dealerTicketFormType',
        defaultMessage: 'Dealer Form Type'
    },
    TABLE_IT_CREATION_TIME: {
        id: 'techDoc.internalList.table.itCreationDate',
        defaultMessage: 'IT Creation Date'
    },
    TABLE_IT_CREATED_BY: {
        id: 'techDoc.internalList.table.itCreatedBy',
        defaultMessage: 'IT Created by (IPN)'
    },
    TABLE_SG_REQUESTOR: {
        id: 'techDoc.internalList.table.sgRequestor',
        defaultMessage: 'SG Requestor'
    },
    TABLE_ASSIGNED_SOLUTION_GROUP: {
        id: 'techDoc.internalList.table.assignedSolutionGroup',
        defaultMessage: 'Assigned SG'
    },
    TABLE_DEALER_CLIENT_ID: {
        id: 'techDoc.internalList.table.clientId',
        defaultMessage: 'Client ID'
    },
    TABLE_DEALER_REGION: {
        id: 'techDoc.internalList.table.region',
        defaultMessage: 'Region'
    },
    TABLE_DEALER_COUNTRY_CODE_3: {
        id: 'techDoc.internalList.table.countryCode3',
        defaultMessage: 'Country Code'
    },
    TABLE_IT_DEALER_NUMBER: {
        id: 'techDoc.internalList.table.dealerNumber',
        defaultMessage: 'Dealer No.'
    },
    TABLE_PART_NUMBER: {
        id: 'techDoc.internalList.table.partNumber',
        defaultMessage: 'Part No.'
    },
    TABLE_MANAGEMENT_GRP: {
        id: 'techDoc.internalList.table.managementGrp',
        defaultMessage: 'Management Group'
    },
    TABLE_PARTNER: {
        id: 'techDoc.internalList.table.partner',
        defaultMessage: 'Partner'
    },
    TABLE_PARTNER_NAME: {
        id: 'techDoc.internalList.table.partnerName',
        defaultMessage: 'Partner Name'
    },
    TABLE_IT_LAST_STATUS_DATE: {
        id: 'techDoc.internalList.table.lastStatusDate',
        defaultMessage: 'Last Status Date'
    },
    TABLE_IT_LAST_EDITOR: {
        id: 'techDoc.internalList.table.lastEditor',
        defaultMessage: 'Last Editor'
    },
});

export default messages;
